module.exports = __webpack_public_path__ + "img/image-010.3aa01702.png";